import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const QA = [
  ["Can PMP support prototypes and production?", "PMP lists capabilities spanning prototype and production quantities. Share your expected volume and project stage so the team can discuss the requirement."],
  ["Can PMP help with assembly work?", "PMP offers build-to-order sub-assembly and full-assembly production. Include the assembly scope and supporting requirements with your inquiry."],
  ["What should I include in my inquiry?", "Start with the part description, material, estimated quantity, critical features, and requested delivery date. Include any inspection or documentation needs."],
  ["How should I share drawings or models?", "Contact the team to confirm the appropriate transfer method for your project files. Avoid placing sensitive technical information in a general website chat."],
  ["What will my project cost, and how long will it take?", "Pricing and timing depend on the project requirements and available capacity. Request a quote for an assessment of your specific job."],
];

// L — FAQ accordion.
export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="faq-section" className="on-light bg-[var(--cream)] py-24 sm:py-32">
      <div className="wrap max-w-4xl">
        <SectionHead no="09" eyebrow="COMMON QUESTIONS" title={<>Before we discuss <span className="font-serif-i">your part.</span></>} />
        <div className="mt-12 border-t border-[var(--line)]">
          {QA.map(([q, a], i) => (
            <Reveal key={q} delay={i * 0.04}>
              <div className="border-b border-[var(--line)]">
                <button
                  type="button"
                  data-testid={`faq-item-${i + 1}`}
                  aria-expanded={open === i}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="text-[17px] font-medium tracking-[-0.01em] text-[var(--ink)] sm:text-lg">{q}</span>
                  <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }} className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${open === i ? "border-[var(--blue)] text-[var(--blue)]" : "border-[var(--line)] text-[var(--grey)]"}`}>
                    <Plus className="h-4 w-4" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-3xl pb-7 text-[15px] leading-relaxed text-[var(--grey)] [text-wrap:pretty]">{a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
